import React from 'react';
const DocumentSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M4.66797 11H10.668M4.66797 15H12.668M9.66797 1H1.66797V19H15.668V7M9.66797 1H10.668L15.668 6V7M9.66797 1V5C9.66797 6 10.668 7 11.668 7H15.668"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentSVG;
